import { Component, Input, OnInit,EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Payers } from '../../../../api/models';
import { validateAllFormFields } from '../../../../formUtils';
import { FinancialService } from '../../../../api/services';
import { CareFinitySession } from '../../../services/CareFinitySession';
import { MessageService } from 'primeng/api';
@Component({
    selector: 'app-add-insurance',
    templateUrl: './add-insurance.component.html',
    styleUrl: './add-insurance.component.css'
})


export class AddInsuranceComponent {

    insuranceForm!: FormGroup;


    @Input()
    payers: Payers[]

    @Output()
    payerAdded = new EventEmitter<string>();
    payorTypes = [{

        value: 1, label: "Primary"
    },
     { value: 2, label: "Secondary" },
        {  value:3,label:"Tertiary"
    }]



    constructor(private fb: FormBuilder,
        private financialService: FinancialService, private messageService: MessageService) { }

    ngOnInit(): void {
        this.initializeForm();
    }


    private initializeForm(): void {
        this.insuranceForm = this.fb.group({
            payerId: ['', [Validators.required]],

            policyNumber: ['', [Validators.required, Validators.minLength(3)]],
            groupNumber: ['', [Validators.required, Validators.minLength(2)]],
            effectiveDate: ['', [Validators.required]],
            policyExpiryDate: ['', [Validators.required]],
            payorType: ['', [Validators.required]]
          

        });
    }

    // Custom validator to ensure expiry date is after effective date
    private dateRangeValidator(form: FormGroup) {
        const effectiveDate = form.get('effectiveDate')?.value;
        const expiryDate = form.get('policyExpiryDate')?.value;

        if (effectiveDate && expiryDate) {
            const effective = new Date(effectiveDate);
            const expiry = new Date(expiryDate);

            if (effective >= expiry) {
                return { dateRange: true };
            }
        }
        return null;
    }



    onSubmit(): void {

        validateAllFormFields(this.insuranceForm)

        if (this.insuranceForm.invalid) {

            console.log(this.insuranceForm.errors)
            return
        }

        this.financialService.financialUpdatePayers({
            body: { ...this.insuranceForm.value, practiceId: CareFinitySession.getLocalItem("EmrPracticeId"), personId: sessionStorage.getItem('ptId') }
        }).subscribe(_ => {


            this.messageService.add({
                key: 'alertToast',
                severity: 'success',
                summary: 'Confirmation',
                detail: "Payor Created Successfully",
                life: 5000,
            })
            this.insuranceForm.reset();

            this.payerAdded.emit("payer added");

        })

    }









}

